import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseB2BCustomer() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      firstName: isEmpty(state.firstName),
      lastName: isEmpty(state.lastName),
      mobile: isEmpty(state.mobile),
    };

    setter(errorState);

    if (errorState.firstName || errorState.lastName || errorState.mobile) {
      enqueueSnackbar("لطفا اطلاعات کاربر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getCustomerList = (state, myPC, search, callback, bool) => {
    let newMyPc = myPC;

    if (myPC.sortColumn == "OrgenizeType") {
      newMyPc.sortColumn = "OrgenizeTypeId";
    }
    if (myPC.sortColumn == "SuspendTitle") {
      newMyPc.sortColumn = "Suspend";
    }
    MyAxios.get(
      `Admin_Marketing_B2BCustomers?w=${search}&s=${
        state.suspend ? state.suspend - 1 : ""
      }&ot=${state.orgenizeTypeID ? state.orgenizeTypeID : ""}&o=${
        state.orgenizeID ? state.orgenizeID : ""
      }`,
      {
        headers: {
          IsPage: bool,
          Conditions: JSON.stringify({ pageCondition: newMyPc }),
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCustomerByID = (id, mobile, callback) => {
    MyAxios.get(`Admin_Marketing_B2BCustomers/${id}/${mobile}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateCustomer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.put(`Admin_Marketing_B2BCustomers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("مشتری با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addCustomer = (state, callback) => {
    const data = new FormData();
    data.append("ID", state);

    MyAxios.post(`Admin_Marketing_B2BCustomers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("مشتری با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCustomer = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Marketing_B2BCustomers`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("مشتری با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const getOrgenizationsList = (callback) => {
    MyAxios.get(`Admin_Marketing_B2BCustomers/orgenizations`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    getCustomerList,
    getCustomerByID,
    validate,
    updateCustomer,
    deleteCustomer,
    addCustomer,
    getOrgenizationsList,
  };
}
